import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

export const FilterIcon = createIcon({
  displayName: 'FilterIcon',
  viewBox: '0 0 24 24',
  path: <path fill='currentColor' d='M3 5h18l-7 8v6l-4 2v-8L3 5Z' />,
});
